class ScrollSlides extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll('.js-slide-item');
    this.headers = this.querySelectorAll('.js-slide-header');
    this.videoStarted = false;
    this.canvas = this.querySelector('canvas');
    this.announcementBar = document.querySelector('.announcement__wrapper');
    this.header = document.querySelector('.header__wrapper');

    if ( this.announcementBar && this.header) {
      this.header.style.transitionDuration = '0.2s';
    }
  }

  connectedCallback() {
    this.video = this.querySelector('video');
    this.startColor = this.dataset.bgStart || "#ffffff";
    this.endColor = this.dataset.bgEnd || "#000000";
    this.endImage = this.querySelector('.js-bg-image-end');

    if (this.canvas) {
      this.initCanvas();
    }

    window.addEventListener('scroll', () => this.onScroll());
    this.onScroll();
  }


  initCanvas() {
    this.frameCount = 140;
    this.baseUrl = "https://cdn.shopify.com/s/files/1/0054/2490/6289/files/HB_IMG_SEQ_";
    this.suffix = "_converted.webp?v=1763999209";
    this.isMobile = window.innerWidth < 989;
    this.barState = null;

    this.frameStep = this.isMobile ? 2 : 1;

    this.images = [];
    this.loaded = 0;
    this.targetFrame = 1;
    this.currentFrame = 1;

    this.ctx = this.canvas.getContext("2d");
    this.lastDraw = 0;

    this.preloadFrames();
    this.animateCanvas();
  }

  preloadFrames() {
    const loadedCount = this.frameCount;
    this.images = new Array(loadedCount);

    for (let loadedIndex = 0; loadedIndex < loadedCount; loadedIndex++) {
      const originalFrame = loadedIndex + 1;
      const img = new Image();
      img.src = `${this.baseUrl}${String(originalFrame).padStart(4, "0")}${this.suffix}`;

      img.onload = () => {
        this.loaded++;
        if (this.loaded === 1) {
          const dpr = window.devicePixelRatio || 1;
          const displayWidth = this.canvas.clientWidth;
          const ratio = img.height / img.width;

          this.canvas.width = displayWidth * dpr;
          this.canvas.height = (displayWidth * ratio) * dpr;

          if (this.isMobile) {
            this.canvas.width = 500;
            this.canvas.height = 500;
          }

          this.drawFrame(1);
        }
      };

      this.images[loadedIndex] = img;
    }
  }

  animateCanvas() {
    const stepSize = 1;
    if (this.currentFrame !== this.targetFrame) {
      const direction = Math.sign(this.targetFrame - this.currentFrame);
      this.currentFrame += direction * stepSize;
      if (Math.abs(this.currentFrame - this.targetFrame) < stepSize) {
        this.currentFrame = this.targetFrame;
      }
      this.drawFrame(this.currentFrame);
    }
    requestAnimationFrame(() => this.animateCanvas());
  }

  drawFrame(frame) {
    if (this.lastFrame === frame) return;
    this.lastFrame = frame;

    const loadedIndex = frame - 1;
    frame = Math.floor(frame / this.frameStep) * this.frameStep;
    frame = Math.max(1, Math.min(frame, this.frameCount));

    const img = this.images[loadedIndex];
    if (!img) return;

    if (this.isMobile) {
      const now = performance.now();
      if (now - this.lastDraw < 16) return;
      this.lastDraw = now;
    }
    this.ctx.imageSmoothingEnabled = true;
    this.ctx.imageSmoothingQuality = 'high';

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
  }

  onScroll() {
    const rect = this.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const sectionHeight = rect.height - viewportHeight;
    const extendedScrollDistance = viewportHeight + sectionHeight;
    const extendedProgress = (viewportHeight - rect.top) / extendedScrollDistance;
    const progress = Math.min(Math.max(extendedProgress, 0), 1);

    this.slideChangePoints = [0, 0.5, 0.8, 1.0];

    let index = 0;
    for (let i = 1; i < this.slideChangePoints.length; i++) {
      if (progress >= this.slideChangePoints[i - 1] && progress < this.slideChangePoints[i]) {
        index = i - 1;
        break;
      }
    }

    if (progress >= this.slideChangePoints[this.slideChangePoints.length - 1]) {
      index = this.slides.length - 1;
    }

    index = Math.max(0, Math.min(index, this.slides.length - 1));

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });

    this.headers.forEach((header, i) => {
      header.classList.toggle('active', i === index);
    });

    if (this.video && index >= 0 && !this.videoStarted) {
      this.video.play();
      this.videoStarted = true;
    }

    if (!this.endImage) {
      const bg = this.lerpColor(this.startColor, this.endColor, progress);
      this.style.backgroundColor = bg;
      const isInViewport = rect.bottom > 0 && rect.top < window.innerHeight;
      document.body.style.backgroundColor = isInViewport ? bg : "";
    }

    if (this.endImage) {
      this.endImage.style.opacity = progress;
    }

    this.targetFrame = Math.floor(progress * this.frameCount);
    if (this.targetFrame < 1) this.targetFrame = 1;
    if (this.targetFrame > this.frameCount) this.targetFrame = this.frameCount;

    if (this.announcementBar && this.isMobile && this.header) {
      const isInViewport = rect.bottom > 0 && rect.top < window.innerHeight;
      const newState = isInViewport ? 'hidden' : 'shown';

      if (!this.barState || this.barState !== newState) {
        this.barState = newState;

        if (isInViewport) {
          this.header.style.top = '0px';
        } else {
          this.header.style.top = '';
        }
      }
    }
  }

  lerpColor(a, b, amount) {
    const ah = parseInt(a.replace(/#/g, ""), 16),
      ar = ah >> 16, ag = (ah >> 8) & 0xff, ab = ah & 0xff,
      bh = parseInt(b.replace(/#/g, ""), 16),
      br = bh >> 16, bg = (bh >> 8) & 0xff, bb = bh & 0xff,
      rr = ar + amount * (br - ar),
      rg = ag + amount * (bg - ag),
      rb = ab + amount * (bb - ab);

    return "#" + (((1 << 24) + (rr << 16) + (rg << 8) + (rb | 0)).toString(16).slice(1));
  }
}

customElements.define('scroll-slides', ScrollSlides);
